import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import API from '../../api-graphql';
import { withStyles, LinearProgress, Grid } from '@material-ui/core';
import sharedStyles from '../UI/sharedStyles';
import { withTranslation } from 'react-i18next';
import PdfViewer from './PdfViewer';

const styles = theme => ({
  ...sharedStyles(theme),
  titleBar: {
    width: '95%',
    margin: 'auto',
    padding: '8px 0'
  },
  showAttachListBtn: {
    marginRight: 16,
    display: 'inline-flex',
    [theme.breakpoints.up('bg')]: {
      display: 'none'
    }
  }
});

const Viewer = (props) => {
  const [loading, setLoading] = useState(true);
  const [input, setInput] = useState({});
  const [pdfUrl, setPdfUrl] = useState(null);
  const { classes, document, type, match, bundleDocument } = props;

  const getData = async () => {
    setLoading(true);
    try {
      let input, result;
      switch (type) {
        case 'template':
          result = await API.getTemplate(match.params.number);
          input = result.data.getTemplate;
          break;
        case 'document':
          input = document;
          break;
        case 'bundle':
          input = {
            items: document,
            type: 'bundle',
            bundleDocument
          };
          break;
        default:
          break;
      }
      if (input) {
        if (input.type !== 'bundle') {
          const ext = input.fileUrl.split('.').pop();
          setPdfUrl(input.fileUrl.replace(`.${ext}`, '.pdf'));
        } else if (input.type === 'bundle' && type === 'document') { // Se cambia el type para que funcionen como un documento
          input.type = 'document';
          const ext = input.fileUrl.split('.').pop();
          setPdfUrl(input.fileUrl.replace(`.${ext}`, '.pdf'));
        } else {
          setPdfUrl(input.items.map(document => {
            const ext = document.fileUrl.split('.').pop();
            return document.fileUrl.replace(`.${ext}`, '.pdf');
          }));
        }
      }
      setInput(input);
      setLoading(false);
    } catch (error) {
      console.error('Error getting data ', error);
    }
  };

  useEffect(() => {
    getData(props);
  }, [bundleDocument, document]);

  if (loading) {
    return (
      <div style={{ padding: 0, position: 'absolute', left: 0, width: '100%', zIndex: 9999 }}>
        <LinearProgress />
      </div>
    );
  }

  return (
    <div className='document-lastStep' style={{ position: 'relative', marginTop: type === 'bundle' && 15 }}>
      { type !== 'bundle' && input &&
        <Grid container direction='row' justify='space-between' className={classes.titleBar}>
          <div style={{ flexGrow: 2 }}>&nbsp;</div>
        </Grid>
      }
      <PdfViewer getData={getData} type={type} input={input} pdfUrl={pdfUrl} />
    </div>
  );
};

Viewer.propTypes = {
  classes: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
  type: PropTypes.string,
  t: PropTypes.func.isRequired,
  bundleDocument: PropTypes.object,
  document: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.arrayOf(PropTypes.object)
  ])
};

export default withTranslation()(withStyles(styles, { withTheme: true })(Viewer));
